import { MessageSquare, Loader2, RefreshCw } from 'lucide-react';

// Extraído de WhatsAppPanel.jsx (02.3-client.md paso b) -- la vista de "no conectado" (QR /
// instrucciones / botón de generar código), mostrada mientras `status !== 'connected'`. Estilos
// inline preservados verbatim.
export default function WhatsAppConnectView({ status, qrCode, onConnect }) {
  return (
    <div style={{ padding: 'var(--space-6) var(--space-5)', display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between', minHeight: '500px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 'var(--space-5)' }}>
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: 'rgba(249, 115, 22, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#f97316'
        }}>
          <MessageSquare size={28} />
        </div>

        <div>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#f3f4f6', marginBottom: 'var(--space-2)' }}>Vincular WhatsApp</h3>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
            Envía y recibe mensajes de WhatsApp en tiempo real integrados directamente con tus clientes.
          </p>
        </div>

        {status === 'qr_ready' && qrCode ? (
          <div style={{
            background: '#fff',
            padding: 'var(--space-3)',
            borderRadius: 'var(--radius-lg)',
            boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '200px',
            height: '200px',
            position: 'relative'
          }}>
            <img src={qrCode} alt="WhatsApp QR Code" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          </div>
        ) : (
          <div style={{
            width: '200px',
            height: '200px',
            background: '#1c1c1e',
            borderRadius: 'var(--radius-lg)',
            border: '1px dashed rgba(255, 255, 255, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-3)',
            color: 'rgba(255,255,255,0.3)'
          }}>
            <Loader2 size={32} style={{ color: '#f97316', animation: 'spin 1.5s linear infinite' }} />
            <span style={{ fontSize: '12px' }}>
              {status === 'connecting' ? 'Generando QR...' : 'Esperando conexión...'}
            </span>
          </div>
        )}

        <div style={{ alignSelf: 'stretch', textAlign: 'left', background: '#1c1c1e', padding: 'var(--space-4)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(255,255,255,0.04)' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: 'rgba(255,255,255,0.7)', marginBottom: 'var(--space-2)' }}>Instrucciones de escaneo:</div>
          <ol style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', paddingLeft: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-2)', lineHeight: '1.4' }}>
            <li>Abre WhatsApp en tu teléfono celular.</li>
            <li>Toca Menú o Configuración y selecciona "Dispositivos vinculados".</li>
            <li>Toca "Vincular un dispositivo" y apunta tu cámara hacia esta pantalla.</li>
          </ol>
        </div>
      </div>

      {status === 'disconnected' && (
        <button
          onClick={onConnect}
          style={{
            background: '#f97316',
            color: '#fff',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--space-3)',
            fontWeight: '600',
            fontSize: '13px',
            cursor: 'pointer',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-2)',
            boxShadow: '0 4px 12px rgba(249, 115, 22, 0.2)',
            transition: 'background .2s',
            marginTop: 'var(--space-4)'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#ea580c'}
          onMouseLeave={e => e.currentTarget.style.background = '#f97316'}
        >
          <RefreshCw size={16} />
          Generar Código QR
        </button>
      )}
    </div>
  );
}
